import { Box, Typography, Card, CardContent, Button, TextField, MenuItem } from '@mui/material'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { FormOutlined } from "@ant-design/icons";
import { useState } from 'react';
import useSurveyImageData from './hooks/useSurveyImageData';

const cardBodyStyle = {
  border: ' grey',
  background: '#fafaeb',
  textAlign: 'center',
  m: 2,
  width: '90%',
}
const thaiAlphabet = [
  "ก", "ข", "ฃ", "ค", "ฅ", "ฆ", "ง", "จ", "ฉ", "ช", "ซ", "ฌ", "ญ",
  "ฎ", "ฏ", "ฐ", "ฑ", "ฒ", "ณ", "ด", "ต", "ถ", "ท", "ธ", "น", "บ",
  "ป", "ผ", "ฝ", "พ", "ฟ", "ภ", "ม", "ย", "ร", "ฤ", "ล", "ฦ", "ว",
  "ศ", "ษ", "ส", "ห", "ฬ", "อ", "ฮ"
];

export default function SurveyImageHome() {

  const [searchValue, setSearchValue] = useState("ก")
  // Custom Hooks
  const { handleSubmitSearch } = useSurveyImageData()

  return (
    <Box className='otherSide' id="otherSide">
      <Box className='surveyLayouts' id="surveyLayouts">
        <Card sx={cardBodyStyle}>
          <CardContent >
            <Typography variant='h5'>ข้อมูลภาพถ่ายสำรวจ</Typography>
          </CardContent>
          <CardContent>
            <Box
              mb={2}
              component="form"
              onSubmit={handleSubmitSearch}
              align="center"
            >
              <Typography variant="h6" sx={{ mb: 1 }}>
                เลือกตัวอักษรไทย
              </Typography>

              <TextField
                label="ตัวอักษร"
                select
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                helperText={searchValue ? `คุณเลือก: ${searchValue}` : "กรุณาเลือกตัวอักษร"}
              >
                {thaiAlphabet.map((ch) => (
                  <MenuItem key={ch} value={ch}>
                    {ch}
                  </MenuItem>
                ))}
              </TextField>
              <Button
                variant="contained"
                color="primary"
                // onClick={handleSearch}
                type="submit"
                sx={{ ml: 1, fontSize: '1.1rem', py: 1.5 }}
              >
                🔍 ค้นหา
              </Button>
            </Box>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">ชื่อเจ้าของทรัพย์สิน</TableCell>
                    <TableCell align="center">รหัสแปลงที่ดินเก่า</TableCell>
                    <TableCell align="center">ประเภทเอกสารสิทธิ์ที่ดิน</TableCell>
                    <TableCell align="center">เลขเอกสารสิทธิ์ที่ดิน</TableCell>
                    <TableCell align="center">วันที่ถ่าย</TableCell>
                    <TableCell align="center">วันที่แก้ไข</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Box>
    </Box>
  )
}
